import { ERevenueAgencyFakeType } from '../../enum'

// Create a union type of all possible values from the enum
type IRevenueAgencyFakeTypeLangKey = `${ERevenueAgencyFakeType}`

export type IRevenueAgencyFakeTypeLang = {
	revenue_agency_fake_type: Record<IRevenueAgencyFakeTypeLangKey, string>
}

const langEntries = Object.entries(ERevenueAgencyFakeType).map(
	([key, value]) => [value, `revenue_agency_fake_type.${value}`]
)

const langObj: Record<IRevenueAgencyFakeTypeLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_AGENCY_FAKE_TYPE_LANG_KEY: IRevenueAgencyFakeTypeLang = {
	revenue_agency_fake_type: langObj
}
